
import React, { useEffect, useState } from "react";
import { getAllEmployees } from "../../api/employeeApi";
import { useNavigate } from "react-router-dom";
import EmployeeFormContainer from "../EmployeeRegistration/EmployeeFormContainer"; // import form
import "../../css/employeemaster.css";


import { hasRight } from "../../utils/userRights"; 

const EmployeeList = () => {
  const [employees, setEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [showForm, setShowForm] = useState(false);
  const navigate = useNavigate();


  const [isFirstPage, setIsFirstPage] = useState(true); // new flag



  useEffect(() => {
    fetchEmployees();
  }, []);

  const fetchEmployees = async () => {
    try {
      const data = await getAllEmployees();
      setEmployees(data);
    } catch (error) {
      console.error("Error fetching employees", error);
    }
  };

  // Filter employees by name
  const filteredEmployees = employees.filter((emp) =>
    emp.fullName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleEdit = (id) => {
    navigate(`/employee/edit/${id}`);
  };

  // Show Add Form only

  if (showForm) {
  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3 add-employee-header">
        <h2>Add Employee</h2>

        {isFirstPage && (  // show Back button only on first page
          <button className="btn btn-secondary" onClick={() => setShowForm(false)}>
            ← Back to List
          </button>
        )}
      </div>

      <EmployeeFormContainer
        onEmployeeAdded={() => {
          fetchEmployees();
          setShowForm(false); // after add, go back to list
        }}
        onPageChange={(pageNumber) => {
          setIsFirstPage(pageNumber === 1); // update first page flag if your form exposes page number
        }}
      />
    </div>
  );
}


  //Default: Show Employee List  style={{ maxHeight: "calc(100vh - 100px)", overflowY: "auto" }}
  return (
    <div className="container mt-4 compact-form compact-table-container">
  <div className="d-flex justify-content-between align-items-center mb-3">
    <h2 className="compact-heading">Employee List</h2>
    <div className="d-flex gap-2">
      <input
        type="text"
        className="form-control"
        style={{ width: "250px" }}
        placeholder="Search by name..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {/* <button className="btn btn-success" onClick={() => setShowForm(true)}>
        ➕ Add Employee
      </button> */}
      {hasRight("AddEmployee", "add") && (
        <button
          className="btn btn-success"
          onClick={() => setShowForm(true)}
        >
          ➕ Add Employee
        </button>
      )}
    </div>
  </div>

  <table className="compact-table">
    <thead className="table-dark">
      <tr>
        <th>ID</th>
        <th>Code</th>
        <th>Full Name</th>
        <th>Contact</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>{filteredEmployees.length > 0 ? (
        filteredEmployees.map((emp, index) => (
          <tr key={emp.employeeCode}>
            <td>{index + 1}</td> {/* SrNo */}
            <td>{emp.employeeCode}</td>
            <td>{emp.fullName}</td>
            <td>{emp.phoneNo1}</td>
            <td>{hasRight("AddEmployee", "update") && (
              <button
                className="edit btn btn-primary btn-sm"
                onClick={() => handleEdit(emp.employeeID)}
              >
                Edit
              </button>
              )}
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td colSpan="5" className="text-center">
            No employees found
          </td>
        </tr>
      )}</tbody>
  </table>
</div>
  );
};

export default EmployeeList;


